import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import messages from './messages';

type RenameDocumentDialogProps = {
  open: boolean;
  onClose: () => void;
  action: (newName: string) => void;
  dialogTitle: string;
  oldDocumentName: string | null;
};
const RenameDocumentDialog = (props: RenameDocumentDialogProps) => {
  const [newName, setNewName] = useState<string | null>(null);

  return (
    <Dialog
      open={props.open}
      onClose={() => {
        props.onClose();
        setNewName(null);
      }}
    >
      <DialogTitle id="rename-dialog-title">{props.dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {props.oldDocumentName ? (
            <FormattedMessage
              {...messages.renameDocumentDialogPrompt}
              values={{
                documentName: props.oldDocumentName,
              }}
            />
          ) : null}
        </DialogContentText>
        <TextField
          variant="standard"
          size="small"
          id="newName"
          label={<FormattedMessage {...messages.renameDocumentDialogNewName} />}
          fullWidth
          onChange={(e) => setNewName(e.target.value)}
        />
        <DialogActions>
          <Button
            onClick={() => {
              props.onClose();
              setNewName(null);
            }}
            color="primary"
          >
            <FormattedMessage {...messages.renameDocumentDialogConfirmCancel} />
          </Button>
          <Button
            onClick={() => {
              if (newName) {
                props.action(newName);
              }
              setNewName(null);
            }}
            color="primary"
          >
            <FormattedMessage {...messages.renameDocumentDialogConfirmRename} />
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default RenameDocumentDialog;
